import * as React from "react";
import { HighlightArea } from "@/components/feature/pdf/types";

export const getHighlightCss = (area: HighlightArea, rotation: number): React.CSSProperties => {
  const normalizedRotation = ((rotation % 360) + 360) % 360;
  const { left, top, width, height } = area;

  let rotated: Pick<HighlightArea, "left" | "top" | "width" | "height">;
  switch (normalizedRotation) {
    case 90:
      rotated = { left: 100 - (top + height), top: left, width: height, height: width };
      break;
    case 180:
      rotated = { left: 100 - (left + width), top: 100 - (top + height), width, height };
      break;
    case 270:
      rotated = { left: top, top: 100 - (left + width), width: height, height: width };
      break;
    default:
      rotated = { left, top, width, height };
  }

  return {
    position: "absolute",
    left: `${rotated.left}%`,
    top: `${rotated.top}%`,
    width: `${rotated.width}%`,
    height: `${rotated.height}%`,
  };
};
